import type { BiddingZone } from "../../../services/client";

export type PriceZoneKey = "BE" | "DE";

export const PRICE_ZONES: Record<
  PriceZoneKey,
  { label: string; biddingZone: BiddingZone }
> = {
  BE: { label: "Belgium", biddingZone: "BE" },
  DE: { label: "Germany", biddingZone: "DE_LU" },
};
